import React from 'react';
import { companyInfo } from '../data/mock';
import { Mail, Phone, MapPin } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../data/translations';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <img 
            src="/logo.jpeg" 
            alt={companyInfo.name}
            className="footer-logo"
          />
          <p className="body-medium footer-description">
            {t('footer.tagline')}
          </p>
        </div>

        <div className="footer-section">
          <h4 className="heading-3 footer-heading">{t('footer.quickLinks')}</h4>
          <button onClick={() => scrollToSection('home')} className="footer-link">{t('nav.home')}</button>
          <button onClick={() => scrollToSection('services')} className="footer-link">{t('nav.services')}</button>
          <button onClick={() => scrollToSection('about')} className="footer-link">{t('nav.about')}</button>
          <button onClick={() => scrollToSection('contact')} className="footer-link">{t('nav.contact')}</button>
        </div>

        <div className="footer-section">
          <h4 className="heading-3 footer-heading">{t('footer.contact')}</h4>
          <div className="footer-contact-item">
            <Mail size={16} />
            <span className="body-small">{companyInfo.contact.email}</span>
          </div>
          <div className="footer-contact-item">
            <Phone size={16} />
            <span className="body-small">{companyInfo.contact.phone1} • {companyInfo.contact.phone2}</span>
          </div>
          <div className="footer-contact-item">
            <MapPin size={16} />
            <span className="body-small">{t('contact.pobox')}: {companyInfo.contact.pobox}, {companyInfo.contact.city} - {t('contact.country')}</span>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="body-small">
          © {currentYear} {t('footer.copyright')}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
